import {FormLabel} from "./FormLabel";
import {RadioGroup} from "./RadioGroup";
import {Radio} from "./Radio";

interface ConditionalsFormProps {
    children: {label_id: string; label_name: string}[];
    displayValue: string;
    id: string;
    name: string;
    onBlur: (e: any) => void;
    onChange: (value: string) => void;
    onFocus: (e: any) => void;
}

export const ConditionalsForm = ({
    children,
    displayValue,
    name,
    onBlur,
    onChange,
    onFocus,
}: ConditionalsFormProps) => (
    <FormLabel value={name}>
        <RadioGroup
            value={displayValue}
            onChange={onChange}
            options={children.map((c) => c.label_id)}
        >
            {children.map((child) => (
                <Radio
                    key={child.label_id}
                    value={child.label_id}
                    name={child.label_name}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            ))}
        </RadioGroup>
    </FormLabel>
);
